import { isCheckboxAnchor, isSkipAnchor, mappingKeyFor } from "./anchors";

export const CONFIG_FORMAT = "kayros.document-template-config";
export const CONFIG_VERSION = 1;

export const buildConfigExport = ({
  name,
  anchors = [],
  anchorMappings = {},
}) => ({
  format: CONFIG_FORMAT,
  version: CONFIG_VERSION,
  exportedAt: new Date().toISOString(),
  name: name || null,
  anchors,
  anchorMappings,
});

export const configFileName = (name) => {
  const slug = (name || "template")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
  return `${slug || "template"}-config.json`;
};

export const parseConfigImport = (text) => {
  let parsed;
  try {
    parsed = JSON.parse(text);
  } catch {
    throw Object.assign(new Error("invalid json"), { code: "INVALID_JSON" });
  }

  if (!parsed || typeof parsed !== "object" || Array.isArray(parsed))
    throw Object.assign(new Error("not an object"), { code: "INVALID_SHAPE" });

  const isEnvelope =
    parsed.anchorMappings &&
    typeof parsed.anchorMappings === "object" &&
    !Array.isArray(parsed.anchorMappings);

  const anchorMappings = isEnvelope ? parsed.anchorMappings : parsed;

  if (Object.keys(anchorMappings).length === 0)
    throw Object.assign(new Error("empty"), { code: "EMPTY" });

  const invalid = Object.entries(anchorMappings)
    .filter(([, value]) => {
      if (typeof value === "string") return false;
      return !value || typeof value !== "object" || Array.isArray(value);
    })
    .map(([anchor]) => anchor);
  if (invalid.length > 0)
    throw Object.assign(new Error("invalid entries"), {
      code: "INVALID_ENTRIES",
      anchors: invalid,
    });

  return {
    anchorMappings,
    anchors: Array.isArray(parsed.anchors) ? parsed.anchors : [],
    name: isEnvelope ? parsed.name || null : null,
  };
};

export const diffConfigAgainstAnchors = (anchorMappings, anchors = []) => {
  const mapped = new Set(Object.keys(anchorMappings));

  const uncovered = anchors.filter((anchor) => {
    if (isSkipAnchor(anchor)) return false;
    if (isCheckboxAnchor(anchor)) return !mapped.has(anchor);
    return !mapped.has(mappingKeyFor(anchor));
  });

  const expected = new Set(
    anchors.filter((a) => !isSkipAnchor(a)).map((a) => mappingKeyFor(a)),
  );
  const unknown = [...mapped].filter((key) => !expected.has(key));

  return { uncovered, unknown };
};
